import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
export const LeaveSkeleton = () => (
  <>
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "60px", borderRadius: "24px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "60px", borderRadius: "24px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "60px", borderRadius: "24px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "60px", borderRadius: "24px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "60px", borderRadius: "24px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "60px", borderRadius: "24px" }}
    />
  </>
);

export const ApprovalCardSkeletons = () => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 320px), 1fr))",
      gridGap: "8px",
      width: "100%",
    }}
  >
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "236px", borderRadius: "24px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "236px", borderRadius: "24px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "236px", borderRadius: "24px" }}
    />
  </div>
);
export const PendingCardSkeletons = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      width: "100%",
    }}
  >
    <Skeleton
      baseColor="#F1F6FA"
      style={{
        width: "100%",
        height: "57px",
        borderRadius: "12px",
        borderBottom: "1px solid #f1f6fa",
      }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{
        width: "100%",
        height: "57px",
        borderRadius: "12px",
        borderBottom: "1px solid #f1f6fa",
      }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "57px", borderRadius: "12px" }}
    />
  </div>
);

export const OverviewLoader = () => (
  <div
    style={{
      display: "flex",
      gap: "4px",
      width: "100%",
    }}
  >
    <Skeleton
      baseColor="#F1F6FA"
      style={{
        width: "310px",
        height: "148px",
        borderRadius: "24px",
      }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{
        width: "170px",
        height: "148px",
        borderRadius: "24px",
      }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{
        width: "170px",
        height: "148px",
        borderRadius: "24px",
      }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{
        width: "254px",
        height: "148px",
        borderRadius: "24px",
      }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{
        width: "254px",
        height: "148px",
        borderRadius: "24px",
      }}
    />
  </div>
);

export const CalendarSkeletonLoader = () => {
  const rows = 5;
  const cols = 7;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flexWrap: "wrap",
            flex: "1 1 320px",
          }}
        >
          <Skeleton
            baseColor="#F1F6FA"
            style={{
              width: "165px",
              height: "36px",
              borderRadius: "24px",
            }}
          />
          <Skeleton
            baseColor="#F1F6FA"
            style={{
              width: "80px",
              height: "36px",
              borderRadius: "24px",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            flex: "1 1 220px",
          }}
        >
          <Skeleton
            baseColor="#F1F6FA"
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "9999px",
              marginLeft: "auto",
            }}
          />
          <Skeleton
            baseColor="#F1F6FA"
            style={{
              width: "73px",
              height: "36px",
              borderRadius: "9999px",
            }}
          />
          <Skeleton
            baseColor="#F1F6FA"
            style={{
              width: "83px",
              height: "36px",
              borderRadius: "9999px",
            }}
          />
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
          gap: "4px",
          width: "100%",
        }}
      >
        {Array.from({ length: 1 * 7 }).map((_, index) => (
          <Skeleton
            baseColor="#F1F6FA"
            key={index}
            style={{
              width: "100%",
              height: "40px",
              borderRadius: "12px",
            }}
          />
        ))}
        {Array.from({ length: rows * cols }).map((_, index) => (
          <Skeleton
            baseColor="#F1F6FA"
            key={index}
            style={{
              width: "100%",
              height: "65px",
              borderRadius: "12px",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export const LeaveCalendarSkeleton = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      width: "100%",
    }}
  >
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "300px", borderRadius: "12px" }}
    />
  </div>
);
export const ReporteeSkeleton = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
    }}
  >
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "36px", height: "36px", borderRadius: "12px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "36px", height: "36px", borderRadius: "12px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "36px", height: "36px", borderRadius: "12px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "36px", height: "36px", borderRadius: "12px" }}
    />
  </div>
);

export const TeamManagerLoader = () => (
  <div style={{ display: "flex", flexDirection: "column", gap: "12px", width: "100%" }}>
    {/* <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Skeleton baseColor="#F1F6FA"
        style={{
          width: "147px",
          height: "36px",
          borderRadius: "12px",
          marginRight: "8px",
        }}
      />
      <Skeleton baseColor="#F1F6FA"
        style={{
          width: "147px",
          height: "36px",
          borderRadius: "12px",
          marginRight: "8px",
        }}
      />
      <Skeleton baseColor="#F1F6FA"
        style={{
          width: "147px",
          height: "36px",
          borderRadius: "12px",
          marginRight: "8px",
        }}
      />
      <div style={{ marginLeft: "auto" }}>
        <Skeleton baseColor="#F1F6FA"
          style={{
            width: "147px",
            height: "36px",
            borderRadius: "12px",
          }}
        />
      </div>
    </div> */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Skeleton
        baseColor="#F1F6FA"
        style={{ width: "100%", height: "65px", borderRadius: "12px" }}
      />
      <Skeleton
        baseColor="#F1F6FA"
        style={{ width: "100%", height: "65px", borderRadius: "12px" }}
      />
      <Skeleton
        baseColor="#F1F6FA"
        style={{ width: "100%", height: "65px", borderRadius: "12px" }}
      />
      <Skeleton
        baseColor="#F1F6FA"
        style={{ width: "100%", height: "65px", borderRadius: "12px" }}
      />
      <Skeleton
        baseColor="#F1F6FA"
        style={{ width: "100%", height: "65px", borderRadius: "12px" }}
      />
      <Skeleton
        baseColor="#F1F6FA"
        style={{ width: "100%", height: "65px", borderRadius: "12px" }}
      />
      <Skeleton
        baseColor="#F1F6FA"
        style={{ width: "100%", height: "65px", borderRadius: "12px" }}
      />
      <Skeleton
        baseColor="#F1F6FA"
        style={{ width: "100%", height: "65px", borderRadius: "12px" }}
      />
    </div>
  </div>
);
export const PeopleSkeleton = () => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
      gridGap: "8px",
    }}
  >
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "297px", borderRadius: "12px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "297px", borderRadius: "12px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "297px", borderRadius: "12px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "297px", borderRadius: "12px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "297px", borderRadius: "12px" }}
    />
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "297px", borderRadius: "12px" }}
    />
  </div>
);

export const PeopleDetailsSkeleton = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
    }}
  >
    <div
      style={{
        display: "flex",
        marginTop: "10px",
      }}
    >
      <Skeleton
        circle
        baseColor="#F1F6FA"
        style={{ width: "40px", height: "40px" }}
      />
      <Skeleton
        baseColor="#F1F6FA"
        style={{ width: "200px", height: "40px", marginLeft: "8px" }}
      />
    </div>
    <Skeleton
      baseColor="#F1F6FA"
      style={{ width: "100%", height: "80vh", borderRadius: "12px" ,marginTop: "20px"}}
    />
  </div>
);
